import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "./api";
import { connectSocket, disconnectSocket, subscribe } from "./socket";
import { useAuthPrompt } from "./prompt";

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((u) => {
        setUser(u);
        connectSocket(t);
        subscribe(`user:${u.id}`);
      })
      .catch(() => setToken(null))
      .finally(() => setReady(true));
  }, []);

  const applyAuth = (data) => {
    setToken(data.token);
    setUser(data.user);
    connectSocket(data.token);
    if (data.user?.id) subscribe(`user:${data.user.id}`);
    return data;
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.twoFactorRequired) return r;
    return applyAuth(r);
  };

  const register = (body) => api.post("/auth/register", body).then(applyAuth);
  const verify2fa = (challengeId, code) => api.post("/auth/2fa/verify", { challengeId, code }).then(applyAuth);

  const logout = () => {
    setToken(null);
    setUser(null);
    disconnectSocket();
  };

  return (
    <Ctx.Provider value={{ user, ready, setUser, login, register, verify2fa, logout }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);

export const useGuard = () => {
  const { user } = useAuth();
  const openPrompt = useAuthPrompt();
  return () => {
    if (user) return true;
    openPrompt();
    return false;
  };
};
